export function toJSON() {
  return {
    rating: null,
    wordingType: null,
    retired: false,
    eventType: '',
    visible: true,
    eventTitleColor: '#2e828e',
    keywords: ['book club', 'books', 'bookshelf', 'owl', 'clubs', 'groups'],
    premium: false,
    designType: '0',
    informationColor: '#000000',
    customFonts: ['//fonts.evitecdn.com/assets/fonts/SquareSerifMedium.css'],
    flash: null,
    categories: ['book_club', 'organizations'],
    type: 'panel',
    css: '//g2.evitecdn.com/templates/bookshelf/5689635160326144/custom.css',
    updated: '20180116T113218',
    specialFeatures: null,
    attribution: '',
    publishedDate: null,
    printable: false,
    currentVersionId: '5689635160326144',
    altTag: '',
    versionName: null,
    designTypeName: 'photo_none',
    uyo: false,
    assets: {
      custom_css: '//g2.evitecdn.com/templates/bookshelf/5689635160326144/custom.css',
      mobileImage: '//g1.evitecdn.com/templates/bookshelf/5689635160326144/mobileImage.png',
      thumb_slider: '//g2.evitecdn.com/templates/bookshelf/5689635160326144/thumb_slider.jpg',
      backgroundImage: '//g4.evitecdn.com/templates/bookshelf/5689635160326144/backgroundImage.png',
      thumb_email: '//g0.evitecdn.com/templates/bookshelf/5689635160326144/thumb_email.jpg',
      thumb_3ColumnGrid:
        '//g1.evitecdn.com/templates/bookshelf/5689635160326144/thumb_3ColumnGrid.jpg',
      thumb_mobile: '//g0.evitecdn.com/templates/bookshelf/5689635160326144/thumb_mobile.jpg',
      thumb_smallGallery:
        '//g0.evitecdn.com/templates/bookshelf/5689635160326144/thumb_smallGallery.jpg',
    },
    displayName: 'Bookshelf',
    name: 'bookshelf',
    created: '20171207T130120',
    uploadImages: null,
    popularity: 8.711270094823556,
    imageType: 'events',
    aspectRatio: 1,
    artist: '',
    cardGender: 'ALL',
  };
}

export default {toJSON};
